import React, { useState } from "react";
import { parseTrips } from "../../features/trips/trip.api";
import DataTable from "../../components/Table/DataTable";
import { useNavigate } from "react-router-dom";
import { toast } from "../../components/Toast/Toast";
const headers = [
    { field: "ticketId", headerName: "Ticket Id", renderCell: (row) => row.data?.ticketId },
    { field: "orderId", headerName: "Order Id", renderCell: (row) => row.data?.orderId },
    { field: "reason", headerName: "Reason", renderCell: (row) => row.reason },
];

const TripForm = () => {
    const [file, setFile] = useState(null);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [page, setPage] = useState(0);
    const [loading, setLoading]=useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [total, setTotal] = useState(0);
    const [skippedTrips, setSkippedTrips] = useState([])
    const [parsedTrips, setParsedTrips] = useState(0)
    const navigate = useNavigate()
    const handleFileUpload = (event) => {
        const uploadedFile = event.target.files[0];

        if (uploadedFile && (uploadedFile.type === "application/json" || uploadedFile.type === "text/csv")) {
            setFile(uploadedFile);
            setUploadSuccess(false);
        } else {
            alert("Please upload a valid JSON or CSV file.");
        }
    };

    const handleUpload = async () => {
        if (file) {
         
            try {
                setLoading(true)
                const formData = new FormData();
                formData.append("file", file);
                const resp = await parseTrips(formData);
                setUploadSuccess(true);
            
                if (resp?.skippedTrips?.length > 0) {
                    setSkippedTrips(resp?.skippedTrips || []);
                    setParsedTrips(resp?.parsedTrips?.length || 0)
                    setTotal(resp?.skippedTrips.length);
                } else {
                    toast.success('All Trips are parsed Successfully !')
                    navigate('/trips')
                }
                 setLoading(false)
                setFile('');

            } catch (error) {
                setLoading(false)
                toast.error("Error uploading file",error)
            }
        } else {
            alert("Please select a file to upload.");
        }
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    const paginatedRows = skippedTrips.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const removeFile = () => {
        setFile(null);
        setUploadSuccess(false);
    };

    const handleBack = () => {
        navigate('/trips')
    };

    return (
        <div className="flex h-screen bg-gray-50">
            {/* Left Sidebar */}
            <div className="w-96 bg-white border-r border-gray-200 shadow-sm flex flex-col">
                {/* Header */}
                <div className="p-6 border-b border-gray-200">
                    <button
                        onClick={handleBack}
                        className="text-primary font-medium mb-4 transition-colors"
                    >
                        ← Back
                    </button>
                    <h2 className="text-bold text-gray-900">Upload Files</h2>
                    <p className="text-sm text-gray-500 mt-1">CSV or JSON format</p>
                </div>

                {/* Upload Area */}
                <div className="flex-1 p-6 overflow-y-auto">
                    {!file ? (
                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-12 text-center hover:border-primary transition-colors">
                            <input
                                id="file-upload"
                                type="file"
                                accept=".json,.csv"
                                className="hidden"
                                onChange={handleFileUpload}
                            />

                            <label htmlFor="file-upload" className="cursor-pointer">
                                <div className="flex flex-col items-center gap-4">
                                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                                        <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-lg font-semibold text-gray-700">
                                            Click to upload
                                        </p>
                                        <p className="text-sm text-gray-500 mt-1">
                                            or drag and drop
                                        </p>
                                    </div>
                                    <div className="flex gap-2 text-xs text-gray-500">
                                        <span className="px-3 py-1 bg-gray-100 rounded">CSV</span>
                                        <span className="px-3 py-1 bg-gray-100 rounded">JSON</span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    ) : (
                        <div>
                            {/* Selected File Display */}
                            <div className="p-4 bg-blue-50 rounded-lg border border-primary">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white rounded flex items-center justify-center">
                                            {file.type === "application/json" ? (
                                                <span className="text-blue-600 font-bold text-xs">JSON</span>
                                            ) : (
                                                <span className="text-green-600 font-bold text-xs">CSV</span>
                                            )}
                                        </div>
                                        <div>
                                            <p className="font-medium text-gray-900 text-sm">{file.name}</p>
                                            <p className="text-xs text-gray-500">
                                                {(file.size / 1024).toFixed(2)} KB
                                            </p>
                                        </div>
                                    </div>
                                    <button
                                        onClick={removeFile}
                                        className="text-gray-400 hover:text-red-500 transition-colors"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            {/* Success Message */}
                            {uploadSuccess && (
                                <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center gap-2">
                                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span className="text-sm font-medium text-green-800">Uploaded successfully!</span>
                                </div>
                            )}

                            {/* Upload Button */}
                            <button
                                onClick={handleUpload}
                                disabled={loading}
                                className="w-full mt-6 py-3 px-4 text-sm font-semibold p-2 rounded-md bg-primary text-white border-2 border-transparent hover:bg-white hover:text-primary hover:border-primary transition-colors duration-300"
                            >
                                {loading ? '....Loading' : 'Upload File'}
                            </button>

                            {/* Change File Button */}
                            <label htmlFor="file-upload" className="block mt-3">
                                <input
                                    id="file-upload"
                                    disabled={loading}
                                    type="file"
                                    accept=".json,.csv"
                                    className="hidden"
                                    onChange={handleFileUpload}
                                />
                                <div className="w-full mt-6 py-3 px-4 text-sm text-center font-semibold p-2 rounded-md bg-white text-primary border-2 border-primary hover:bg-primary hover:text-white hover:border-primary transition-colors duration-300 cursor-pointer">
                                    Choose Different File
                                </div>
                            </label>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="p-4 border-t border-gray-200 bg-gray-50">
                    <p className="text-xs text-gray-500 text-center">
                        Max file size: 10MB
                    </p>
                </div>
            </div>

            {/* Main Content Area (Right Side) */}
            <div className="flex-1 p-8">
                <div className="max-w-4xl">
                    <h2 className="text-2xl font-semibold text-gray-900 mb-6">
                        Unparsed or Irrelevant Trips Shown Here!
                    </h2>

                    {/* Display number of skipped trips and parsed trips with badges */}
                    {skippedTrips && skippedTrips.length > 0 ? (
                        <div className="flex items-center gap-4 text-lg">
                            <span className="flex items-center gap-2">
                                <span className="px-3 py-1 bg-red-600 text-white text-xs rounded-full">
                                    {skippedTrips.length} 
                                </span>
                                <span className="text-gray-600">Trips have been skipped</span>
                            </span>

                            <span className="flex items-center gap-2">
                                <span className="px-3 py-1 bg-green-600 text-white text-xs rounded-full">
                                    {parsedTrips} 
                                </span>
                                <span className="text-gray-600">Trips have been parsed</span>
                            </span>
                        </div>
                    ) : (
                        <p className="text-gray-500 text-lg mt-2">No trips have been skipped or parsed yet.</p>
                    )}

                    <DataTable
                        columns={headers}
                        rows={paginatedRows} // Pass paginated rows to the DataTable
                        rowsPerPage={rowsPerPage}
                        totalCount={total}
                        page={page}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default TripForm;